import { HOME_MEDIA, mediaUrl, toAbsoluteUrl } from "../config/api";

export const NOTFOUND_DESCRIPTION =
  "The requested page could not be found. Browse our products, categories and recent deliveries or contact our supply team.";

const DEFAULT_DOCUMENT_TITLE = "Steel, Hardware & Industrial Supplies Malaysia";
const DEFAULT_DOCUMENT_DESCRIPTION =
  "Steel, hardware, fasteners, roofing, paint and industrial products for contractors across Malaysia. Request a quote today.";

const JSON_LD_IDS = [
  "home-jsonld",
  "category-detail-jsonld",
  "category-jsonld",
  "product-jsonld",
  "product-breadcrumb-jsonld",
  "products-collection-jsonld",
  "products-breadcrumb-jsonld",
  "products-itemlist-jsonld",
  "delivery-webpage-jsonld",
  "delivery-breadcrumb-jsonld",
  "deliveries-collection-jsonld",
  "deliveries-breadcrumb-jsonld",
  "deliveries-itemlist-jsonld",
  "about-webpage-jsonld",
  "about-breadcrumb-jsonld",
  "contact-webpage-jsonld",
  "contact-organization-jsonld",
  "contact-breadcrumb-jsonld",
];

function upsertMeta(attr, key, content) {
  const selector = `meta[${attr}="${key}"]`;
  let el = document.head.querySelector(selector);
  if (!content) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
  el.dataset.notfoundSeo = "true";
}

function removeAll(selector) {
  document.head.querySelectorAll(selector).forEach((el) => el.remove());
}

export function notFoundTitle(siteName) {
  const name = String(siteName || "").trim();
  return name ? `Page Not Found | ${name}` : "Page Not Found";
}

export function clearInheritedSeo() {
  removeAll("link[rel='canonical']");
  removeAll("script[type='application/ld+json']");
  JSON_LD_IDS.forEach((id) => document.getElementById(id)?.remove());
  removeAll("[data-home-seo='true']");
  removeAll("[data-product-seo='true']");
  removeAll("[data-products-seo='true']");
  removeAll("[data-delivery-seo='true']");
  removeAll("[data-deliveries-seo='true']");
  removeAll("[data-about-seo='true']");
  removeAll("[data-contact-seo='true']");
  document.head.querySelectorAll("meta[property^='og:'], meta[name^='twitter:']").forEach((el) => {
    if (el.dataset.notfoundSeo !== "true") el.remove();
  });
}

export function applyNotFoundSeo({ siteName } = {}) {
  clearInheritedSeo();
  const title = notFoundTitle(siteName);
  const name = String(siteName || "").trim();
  const imageUrl = toAbsoluteUrl(mediaUrl(HOME_MEDIA.hero));

  document.title = title;
  upsertMeta("name", "description", NOTFOUND_DESCRIPTION);
  upsertMeta("name", "robots", "noindex,follow");
  upsertMeta("name", "prerender-status-code", "404");

  upsertMeta("property", "og:type", "website");
  upsertMeta("property", "og:title", title);
  upsertMeta("property", "og:description", NOTFOUND_DESCRIPTION);
  if (name) upsertMeta("property", "og:site_name", name);
  if (/^https?:\/\//i.test(imageUrl)) upsertMeta("property", "og:image", imageUrl);

  upsertMeta("name", "twitter:card", "summary");
  upsertMeta("name", "twitter:title", title);
  upsertMeta("name", "twitter:description", NOTFOUND_DESCRIPTION);
}

export function clearNotFoundSeo() {
  document.title = DEFAULT_DOCUMENT_TITLE;
  document.head.querySelectorAll("[data-notfound-seo='true']").forEach((el) => el.remove());
  const description = document.head.querySelector('meta[name="description"]');
  if (!description) {
    const el = document.createElement("meta");
    el.setAttribute("name", "description");
    el.setAttribute("content", DEFAULT_DOCUMENT_DESCRIPTION);
    document.head.appendChild(el);
  } else if (!description.getAttribute("content")) {
    description.setAttribute("content", DEFAULT_DOCUMENT_DESCRIPTION);
  }
}
